export const sportsLinkMobileWeb: string = 'https://lvbet.lv/sports/{lang}/';
export const sportsLinkWeb: string = 'https://lvbet.lv/sports/{lang}/';
